module.exports = __webpack_public_path__ + "img/17e5e59.jpg";